import {Controller} from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = ['content'];

    expand() {
        this.contentTarget.style.maxHeight =
            (this.contentTarget.offsetHeight == 0 ? this.contentTarget.scrollHeight : 0) + 'px';
    }
}
